import { ReactElement, useMemo, memo } from 'react';
import { Tooltip, Typography } from '@mui/material';

import { OrderServiceTypeInfoProps } from './types';

const OrderServiceTypeInfo = ({
  serviceType,
}: OrderServiceTypeInfoProps): ReactElement => {
  const value = useMemo(() => serviceType || 'Sin Asignar', [serviceType]);

  return (
    <Tooltip title={value} placement="bottom-start">
      <Typography component="span" variant="body2">
        {value}
      </Typography>
    </Tooltip>
  );
};

export default memo(OrderServiceTypeInfo);
